<template>
  <v-container
    fill-height
    :class="{'bizgain-status-container':isStatusLayout, 'layout-fill-height': !$vuetify.breakpoint.xsOnly}"
    fluid
    class="ma-0 pa-0"
  >
    <bizgain-status-layout :animation-path="animationPath" v-if="isStatusLayout" />
    <v-layout v-else class="white ma-0 pa-0 height-100" ref="layoutContainer">
      <v-flex
        sm4
        xl4
        fluid
        class="ma-0 pa-0 left-panel"
        :style="{
          'min-width': $vuetify.breakpoint.xsOnly ? '' : '33.33%',
        }"
        v-if="!$vuetify.breakpoint.xsOnly"
      >
        <div class="layout-img" />
        <v-card
          class="image-card"
        >
          <v-card-text class="pa-0 image-card-text">
            <div class="bounding-box" v-if="animation">
              <lottie-animation
                :loop="lottieOptions.loop"
                :autoplay="lottieOptions.autoplay"
                :height="$vuetify.breakpoint.mdAndUp ? animation.height : animation.mdHeight"
                :width="$vuetify.breakpoint.mdAndUp ? animation.width : animation.mdWidth"
                :path="animationPath"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm12
        md12
        xl12
        class="ma-0 pa-0"
        style="outline: 1px solid red"
      >
        <v-layout
          class="pa-0"
          v-if="!$vuetify.breakpoint.xsOnly"
          :class="{'ml-5 pt-3 pb-4': !$vuetify.breakpoint.smOnly, 'ml-0 mt-2 mb-3': $vuetify.breakpoint.smOnly}"
          row
          wrap
        >
          <v-flex
            shrink
            xs1
            sm2
            md2
            lg1
            xl1
            v-if="(!$vuetify.breakpoint.xsOnly && (isAgent || !isSummaryPage)) || (!$vuetify.breakpoint.xsOnly && !isSummaryPage)"
          >
            <v-flex>
              <v-list-tile
                class="text-capitalize chat-btn"
                @click="goBack()"
              >
                <v-badge
                  class="pa-0 chat-badge"
                  overlap
                >
                  <v-list-tile-avatar size="25">
                    <v-img
                      v-if="isBackButtonDisabled"
                      class="header-btn"
                      :src="backButtonDisabledIcon"
                      :lazy-src="backButtonDisabledIcon"
                      contain
                    />
                    <v-img
                      v-else
                      class="header-btn"
                      :src="backButtonIcon"
                      :lazy-src="backButtonIcon"
                      contain
                    />
                  </v-list-tile-avatar>
                </v-badge>
                <v-list-tile-content>
                  <v-list-tile-title class="back-btn-xs-text fw-semi-bold" :class="{'back-btn-disabled': isBackButtonDisabled}">
                    {{ $tc('message.bizgainOnboarding.back') }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
          </v-flex>
          <v-flex
            xs9
            sm8
            md8
            lg9
            xl9
            justify-start
            class="step-indicator"
            v-if="!showStepper"
          >
            <step-indicator
              v-if="!$vuetify.breakpoint.xsOnly && !isSummaryPage && !isShortenFlow && !isAutoGenerationFlow"
              :total-steps="totalStepCount"
              :current-step="currentStep"
              :height="stepIndicatorHeight"
              :width="stepIndicatorWidth"
              :active-color="$vuetify.theme.primary"
              :inactive-color="$vuetify.theme.primary"
              :inactive-opacity="0.1"
              :layout-classes="layoutClasses"
            />
          </v-flex>
          <v-flex
            xs9
            sm8
            md8
            lg9
            xl9
            justify-start
            class="step-indicator"
            v-if="showStepper"
          >
            <Stepper />
          </v-flex>
          <v-flex
            sm2
            md2
            lg2
            xl2
            shrink
            justify-center
            v-if="isInAppCampaign && !$vuetify.breakpoint.xsOnly"
          >
            <span
              @click="goToDashboard"
              class="back-btn mt-2"
            >
              <v-icon class="justify-start" d-inline-flex>
                close
              </v-icon>
            </span>
          </v-flex>
        </v-layout>
        <div
          v-if="$vuetify.breakpoint.xsOnly && !isSummaryPage"
          :style="{
            height: '70px',
            position: 'absolute',
            width: '100%'
          }"
        >
          <v-layout
            row
            wrap
            class="layout-header"
          >
            <v-flex
              grow
              xs2
              :xs9="isInAppCampaign && isShortenFlow && !currentStep"
            >
              <v-flex>
                <v-list-tile
                  class="text-capitalize chat-btn"
                  @click="goBack()"
                >
                  <v-badge
                    class="pa-0 chat-badge"
                    overlap
                  >
                    <v-list-tile-avatar size="25">
                      <v-img
                        class="header-btn"
                        :src="arrowBackButtonIcon"
                        :lazy-src="arrowBackButtonIcon"
                        contain
                        :class="{'back-btn-icon-disabled': isBackButtonDisabled}"
                      />
                    </v-list-tile-avatar>
                  </v-badge>
                  <!-- <v-list-tile-content>
                    <v-list-tile-title class="back-btn-xs-text fw-semi-bold" :class="{'back-btn-disabled': isBackButtonDisabled}">
                      {{ $tc('message.bizgainOnboarding.back') }}
                    </v-list-tile-title>
                  </v-list-tile-content> -->
                </v-list-tile>
              </v-flex>
            </v-flex>
            <v-flex
              class="step-indicator"
              :xs8="!isInAppCampaign"
              :xs7="isInAppCampaign"
              v-if="!isSummaryPage && !isShortenFlow"
            >
              <step-indicator
                v-if="$vuetify.breakpoint.xsOnly && !isSummaryPage && !isShortenFlow"
                :total-steps="totalStepCount"
                :current-step="currentStep"
                :height="stepIndicatorHeight"
                :width="stepIndicatorWidth"
                :active-color="$vuetify.theme.primary"
                :inactive-color="$vuetify.theme.primary"
                :inactive-opacity="0.1"
                :layout-classes="layoutClasses"
              />
            </v-flex>
            <v-flex
              class="step-indicator mb-2 pb-2"
              :xs8="!isInAppCampaign"
              :xs7="isInAppCampaign"
              grow
              v-if="showStepper"
            >
              <Stepper />
            </v-flex>
            <v-flex
              class="chat-btn"
              :xs2="!isInAppCampaign"
              :xs1="isInAppCampaign"
              :class="{'pl-3 ml-2': isInAppCampaign, 'pl-3': !isInAppCampaign}"
            >
              <v-flex>
                <v-list-tile
                  class="text-capitalize chat-btn"
                  @click="toggleChatPanel"
                >
                  <!-- <v-list-tile-content>
                    <v-list-tile-title class="chat-btn-xs-text pr-1 fw-semi-bold">
                      {{ $tc('message.bizgainOnboarding.help') }}
                    </v-list-tile-title>
                  </v-list-tile-content> -->
                  <v-badge
                    class="pa-0 chat-badge"
                    overlap
                    :value="chatMessageCount>0"
                  >
                    <template v-slot:badge>
                      <span>{{ (chatMessageCount>0)?chatMessageCount:'' }}</span>
                    </template>
                    <v-img
                      :src="freshChatIcon"
                      :lazy-src="freshChatIcon"
                      alt="Fresh chat Icon"
                      contain
                    />
                  </v-badge>
                </v-list-tile>
              </v-flex>
            </v-flex>
            <v-flex
              v-if="isInAppCampaign"
              class="chat-btn"
              xs1
              ml-3
            >
              <v-flex>
                <v-list-tile
                  class="text-capitalize chat-btn"
                  @click="goToDashboard"
                >
                  <v-list-tile-content>
                    <v-icon class="justify-start" d-inline-flex>
                      close
                    </v-icon>
                  </v-list-tile-content>
                </v-list-tile>
              </v-flex>
            </v-flex>
          </v-layout>
        </div>
        <!-- App Router -->
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </v-flex>
    </v-layout>
    <app-confirmation-dialog
      ref="exitConfirmation"
      :is-heading-enabled="false"
      :message="$t('message.exitConfirmationPrompt')+' ?'"
      @onConfirm="exitApp"
      @onCancel="$refs.exitConfirmation.close()"
      confirm-color="primary"
      :confirm-text="$t('message.exit')"
      cancel-color="primary"
      :cancel-text="$t('message.cancel')"
    />
  </v-container>
</template>
<script>
import { VContainer, VFlex, VLayout, VCard, VCardText, VIcon, VBadge, VListTile, VListTileContent, VListTileTitle, VListTileAvatar, VImg } from 'vuetify/lib';
import StepIndicator from 'Components/StepIndicator/StepIndicator';
import Stepper from '../../components/StepIndicator/Stepper.vue';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import { homeRoutes } from '../home-mobile/constants';
import { fabric } from 'fabric';
import Vue from 'vue';
import './store/Modules/PersistedStore';
import './store/Modules/NonPersistedStore';
import './main.scss';
// import * as animationData from 'Layouts/animation.json';
import BizgainStatusLayout from 'Components/BizgainStatusLayout/BizgainStatusLayout.vue';
import { bizgainOnboardingRoutes, objectiveType, bizgainConfig, launchState, engineDetails } from 'Features/bizgainOnboarding/constants';
import AppConfig from 'Constants/AppConfig';
import AppConfirmationDialog from 'Components/AppConfirmationDialog/AppConfirmationDialog';
import { mapActions, mapGetters } from 'vuex';
import { Chat } from 'Mixins/chat';
import { App } from '@capacitor/app';
import { phoneNoOptions } from './constants';
Vue.use(fabric);
/* Disable fabricjs object caching to fuzzy texts in buttons
   https://stackoverflow.com/questions/42095045/fabric-js-itext-font-fuzzy-according-to-position
*/
// eslint-disable-next-line
if(fabric) {
  // eslint-disable-next-line
  fabric.Object.prototype.objectCaching = false;
  fabric.textureSize = fabric.maxTextureSize;
}
export default {
  mixins: [Chat],
  data() {
    return {
      animation: {
        height: 240,
        width: 240,
        smHeight: 96,
        smWidth: 96,
        mdHeight: 140,
        mdWidth: 140
      },
      lottieOptions: {
        loop: false,
        autoplay: false
      },
      objectiveType,
      launchState,
      engineDetails,
      chatWindowToken: AppConfig.chatWindowToken,
      chatWindowUrl: AppConfig.chatWindowUrl,
      freshChatIcon: bizgainConfig.freshChatIcon,
      facebookIcon: bizgainConfig.facebookIcon,
      backButtonIcon: bizgainConfig.backButtonIcon,
      backButtonDisabledIcon: bizgainConfig.backButtonDisabledIcon,
      arrowBackButtonIcon: bizgainConfig.arrowBackIcon,
      arrowBackButtonDisabledIcon: bizgainConfig.arrowBackDisabledIcon,
      homeRoutes
    };
  },
  computed: {
    ...mapGetters([
      'currentStep',
      'totalStepCount',
      'businessProfileId',
      'isInAppCampaign',
      'chatMessageCount',
      'user',
      'collapseSidebar',
      'businessProfileId',
      'outerNavWidth',
      'disableChatSupport',
      'freshChatRestoreId',
      'freshChatExternalId',
      'businessName',
      'businessDetails',
      'regionConfig',
      'roimaticConfiguration',
      'additionalConfiguration',
      'isAutoGeneratedFlow'
    ]),
    hasCampaignId(){
      return this.$route.params.hasOwnProperty('campaignId');
    },
    hasBusinessProfileId(){
      return this.$route.params.hasOwnProperty('businessProfileId');
    },
    isStatusLayout(){
      return Boolean(this.$route && this.$route.meta && this.$route.meta.isStatusLayout);
    },
    animationPath: function() {
      return this.$route.meta.animationPath;
    },
    stepIndicatorWidth: function() {
      return this.$vuetify.breakpoint.xsOnly ? '53px' : '131px';
    },
    stepIndicatorHeight: function() {
      return '4px';
    },
    isAgent(){
      return !!this.$route.query['agentid'];
    },
    showStepper(){
      return !this.isSummaryPage && this.isShortenFlow && this.totalStepCount && this.currentStep && !this.isAutoGenerationFlow;
    },
    isAutoGenerationFlow(){
      if(this.$route.name == 'setupBusinessInfo' || this.isAutoGeneratedFlow){
        return true;
      }
      return false;
    },
    isShortenFlow(){
      if(this.$route.name == 'businessDetails'){
        return false;
      }
      if((this.businessDetails && this.businessDetails.shortenFlow) || (this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow)){
        return true;
      }
      if(!this.businessDetails && (this.$route.query && !(this.$route.query.normalFlow || this.$route.query.agentid))){
        return true;
      }
      return false;
    },
    selectedChannels(){
      return this.additionalConfiguration && this.additionalConfiguration.localBusiness &&
                            this.additionalConfiguration.localBusiness.channels;
    },
    isGoogleSelected(){
      return this.selectedChannels.indexOf(engineDetails.google.id) >= 0;
    },
    isFbSelected(){
      return this.selectedChannels.indexOf(engineDetails.fb.id) >= 0;
    },
    isInstagramSelected(){
      return this.selectedChannels.indexOf(engineDetails.instagram.id) >= 0;
    },
    backButtonRoute: function() {
      this.clearMessages();
      let routeName = this.$route.meta.backButtonRoute;
      let ls = JSON.parse(localStorage.getItem('bizgain-onboarding'));
      let isAgentFlow = null;
      isAgentFlow = localStorage.getItem('isAgentFlow');
      if (ls.bizgainOnboarding &&
            ls.bizgainOnboarding.businessDetails &&
            ls.bizgainOnboarding.businessDetails.data) {
        switch (this.$route.name) {
          case bizgainOnboardingRoutes.SubsequentSelectObjective.name:
          case bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.name:
            this.goToDashboard();
            break;
          case bizgainOnboardingRoutes.ExtractOfferDetails.name:
            if (Array.isArray(ls.bizgainOnboarding.businessDetails.data.services) &&
            ls.bizgainOnboarding.businessDetails.data.services.length > 1
            ) {
              routeName = bizgainOnboardingRoutes.PromoteServices.name;
            }else if ((Array.isArray(ls.bizgainOnboarding.businessDetails.data.services) &&
            ls.bizgainOnboarding.businessDetails.data.services.length == 1) && (ls.bizgainOnboarding.businessDetails.data.creativeDetail &&
            ls.bizgainOnboarding.businessDetails.data.creativeDetail.objective != this.objectiveType.calls.id))
            {
              routeName = bizgainOnboardingRoutes.SelectObjective.name;
            }
            break;
          case bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name:
            if (Array.isArray(ls.bizgainOnboarding.businessDetails.data.services) &&
            ls.bizgainOnboarding.businessDetails.data.services.length > 1
            ) {
              routeName = bizgainOnboardingRoutes.SubsequentPromoteServices.name;
            }else if ((Array.isArray(ls.bizgainOnboarding.businessDetails.data.services) &&
            ls.bizgainOnboarding.businessDetails.data.services.length == 1) && (ls.bizgainOnboarding.businessDetails.data.creativeDetail &&
            ls.bizgainOnboarding.businessDetails.data.creativeDetail.objective != this.objectiveType.calls.id))
            {
              routeName = bizgainOnboardingRoutes.SubsequentSelectObjective.name;
            }
            break;
          case bizgainOnboardingRoutes.AgeGenderTarget.name:
            if (
              (ls.bizgainOnboarding.businessDetails.data.creativeDetail.objective == this.objectiveType.instantMessages.id) &&
              (routeName != bizgainOnboardingRoutes.EmailSignup.name)
            )
            {
              routeName = bizgainOnboardingRoutes.ImageCreativesAdPreview.name;
            }
            break;
          case bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name:
            if (
              (ls.bizgainOnboarding.businessDetails.data.creativeDetail.objective == this.objectiveType.instantMessages.id) &&
              (routeName != bizgainOnboardingRoutes.EmailSignup.name)
            )
            {
              routeName = bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name;
            }
            break;
          case bizgainOnboardingRoutes.EmailSignup.name:
            if((this.businessDetails && this.businessDetails.shortenFlow)){
              routeName = this.isAutoGenerationFlow ? bizgainOnboardingRoutes.SetupBusinessInfo.name : bizgainOnboardingRoutes.CreativeDetailsV2.name;
            }
            else if(isAgentFlow && !this.businessDetails.businessPhoneNumber && (this.regionConfig.PhoneNoOptions ===  phoneNoOptions.optional)){
              routeName = bizgainOnboardingRoutes.BusinessPhoneNumber.name
            }
            else if(isAgentFlow){
              routeName = bizgainOnboardingRoutes.Summary.name;
            }
            else if (ls.bizgainOnboarding.businessDetails.data.creativeDetail.objective == this.objectiveType.instantMessages.id) {
              routeName = bizgainOnboardingRoutes.ImageCreativesAdPreview.name;
            }
            break;
          case bizgainOnboardingRoutes.Budget.name:
          case bizgainOnboardingRoutes.SubsequentBudget.name:
            if((this.businessDetails && this.businessDetails.shortenFlow)){
              routeName = this.isAutoGenerationFlow ? bizgainOnboardingRoutes.SetupBusinessInfo.name : bizgainOnboardingRoutes.CreativeDetailsV2.name;
            }
            if((this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow)){
              routeName = bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name;
            }
            if(isAgentFlow){
              routeName = bizgainOnboardingRoutes.Summary.name;
            }
            break;
          case bizgainOnboardingRoutes.BusinessPhoneNumber.name:
            if((this.businessDetails && this.businessDetails.shortenFlow)){
              routeName = this.isAutoGenerationFlow ? bizgainOnboardingRoutes.SetupBusinessInfo.name : bizgainOnboardingRoutes.CreativeDetailsV2.name;
            }
            else if(isAgentFlow){
              routeName = bizgainOnboardingRoutes.Summary.name;
            }
            break;
          case bizgainOnboardingRoutes.BusinessTypeServices.name:
            if(!this.businessDetails.businessPhoneNumber && !isAgentFlow && !(this.regionConfig.PhoneNoOptions ===  phoneNoOptions.Disabled)){
              routeName = bizgainOnboardingRoutes.BusinessPhoneNumber.name;
            }
            break;
          case bizgainOnboardingRoutes.Summary.name:
            routeName = bizgainOnboardingRoutes.LocationTargeting.name;
            break;
          case bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name:
          case bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name:
          case bizgainOnboardingRoutes.GoogleAdsEdit.name:
            if((this.businessDetails && this.businessDetails.shortenFlow)){
              routeName = this.isAutoGenerationFlow ? bizgainOnboardingRoutes.SetupBusinessInfo.name : bizgainOnboardingRoutes.CreativeDetailsV2.name;
            }
            break;
          case bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name:
          case bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name:
          case bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name:
            if((this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow)){
              routeName = bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name
            }
            break;
          case bizgainOnboardingRoutes.FacebookInterests.name:
            if(this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow){
              routeName = bizgainOnboardingRoutes.TargetingV2.name;
            }
            break;
          case bizgainOnboardingRoutes.GoogleKeywords.name:
            routeName = this.isShortenFlow ? (this.isFbSelected || this.isInstagramSelected ? bizgainOnboardingRoutes.FacebookInterests.name : bizgainOnboardingRoutes.TargetingV2.name) : (this.isFbSelected || this.isInstagramSelected ? bizgainOnboardingRoutes.FacebookInterests.name : bizgainOnboardingRoutes.ChannelSelection.name);
            break;
          default:
            routeName = this.$route.meta.backButtonRoute;
        }
      }

      return routeName;
    },
    previousRouteParams: function() {
      let ls;
      switch (this.$route.name) {
        case bizgainOnboardingRoutes.GoogleAds.name:
        case bizgainOnboardingRoutes.SubsequentGoogleAds.name:
        case bizgainOnboardingRoutes.GoogleAdsEdit.name:
        case bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name:
        case bizgainOnboardingRoutes.Budget.name:
        case bizgainOnboardingRoutes.SubsequentBudget.name:
        case bizgainOnboardingRoutes.BusinessPhoneNumber.name:
        case bizgainOnboardingRoutes.EmailSignup.name:
          ls = JSON.parse(localStorage.getItem('bizgain-onboarding'));
          if (ls.bizgainOnboarding &&
                ls.bizgainOnboarding.businessDetails &&
                ls.bizgainOnboarding.businessDetails.data && ls.bizgainOnboarding.businessDetails.data.creativeDetail) {
            if (this.isAutoGeneratedFlow){
              return { isAppFlow: true };
            }
            return { id: ls.bizgainOnboarding.businessDetails.data.creativeDetail.selectedTemplateId, isAppFlow: true };
          }
          break;
        case bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name:
        case bizgainOnboardingRoutes.AgeGenderTarget.name:
          ls = JSON.parse(localStorage.getItem('bizgain-onboarding'));
          if (ls.bizgainOnboarding &&
                ls.bizgainOnboarding.businessDetails &&
                ls.bizgainOnboarding.businessDetails.data && ls.bizgainOnboarding.businessDetails.data.creativeDetail &&
                  (ls.bizgainOnboarding.businessDetails.data.creativeDetail.objective == this.objectiveType.instantMessages.id) &&
                    (this.$route.meta.backButtonRoute != bizgainOnboardingRoutes.EmailSignup.name)
          )
          {
            return { id: ls.bizgainOnboarding.businessDetails.data.creativeDetail.selectedTemplateId, isAppFlow: true };
          }
          break;
      }
      return { isAppFlow: true };
    },
    isBackButtonDisabled: function() {
      return this.$route.meta.isBackButtonDisabled;
    },
    layoutClasses: function() {
      return this.$vuetify.breakpoint.width < 370 ? ['mx-0'] : ['mx-0', 'pl-4'];
    },
    badgeBtnClass: function() {
      return this.$vuetify.breakpoint.width < 370 ? 'ml-0' : 'ml-1';
    },
    isSummaryPage: function() {
      return this.$route.name == bizgainOnboardingRoutes.Summary.name;
    }
  },
  methods: {
    ...mapActions(['clearMessages', 'resetRoimaticCampaign', 'setOuterNavWidth', 'setInnerNavWidth', 'initializeFreshChatWidget']),
    goBack() {
      if (this.isBackButtonDisabled) {
        return;
      }

      if (this.isChatPanelOpen()){
        this.closeChatPanel();
      }
      if(this.$route.name == bizgainOnboardingRoutes.SummaryLink.name){
        this.$router.push({ name: bizgainOnboardingRoutes.LocationTargeting.name, params: { isAppFlow: true } });
      }
      else if(this.$route.params.fromSummary){
        this.$router.push({ name: bizgainOnboardingRoutes.Summary.name, params: { isAppFlow: true } });
      }
      else{
        if ((this.$route.name == bizgainOnboardingRoutes.ExtractBusinessDetails.name) || (this.$route.name == bizgainOnboardingRoutes.BusinessDetailsV2.name)) {
          this.$refs.exitConfirmation.openDialog();
        }

        if (this.backButtonRoute) {
          this.$router.replace({ name: this.backButtonRoute, params: this.previousRouteParams });
        }
      }
    },
    exitApp(){
      this.$refs.exitConfirmation.close();
      if (process.env.VUE_APP_CAPACITOR_ENVIRONMENT === 'true')
      {
        this.$router.push(this.homeRoutes.home.path);
      } else {
        window.location.href = 'https://bizgain.com';
      }
    },
    goToDashboard(){
      this.resetRoimaticCampaign();
      this.$router.push({ name: 'dashboard', params: { businessProfileId: this.businessProfileId } });
    },
    setDynamicHeight() {
      let vh = window.innerHeight * 0.01;
      this.$nextTick(() => {
        const layoutContainerElement = this.$refs.layoutContainer;
        if (layoutContainerElement) {
          layoutContainerElement.style.setProperty('--vh', `${vh}px`);
        }
      });
    },
    popStateEventHandler(){
      this.goBack();
      if(process.env.VUE_APP_CAPACITOR_ENVIRONMENT !== 'true'){
        history.pushState(null, document.title, location.href);
      }
    }
  },
  created() {
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
    App.addListener('backButton', () => {
      this.goBack();
    })
  },
  mounted() {
    sessionStorage.setItem('isActiveFlow', true);
    if(process.env.VUE_APP_CAPACITOR_ENVIRONMENT !== 'true'){
      history.pushState(null, document.title, location.href);
    }
    window.addEventListener('popstate', this.popStateEventHandler);
    if(!this.disableChatSupport){
      this.initializeChat(this.freshChatRestoreId, this.freshChatExternalId, this.$vuetify.theme, this.businessProfileId, this.businessName, this.user, this.$vuetify.breakpoint.xsOnly);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setDynamicHeight);
    window.removeEventListener('popstate', this.popStateEventHandler);
  },
  components: {
    VContainer,
    VFlex,
    VLayout,
    StepIndicator,
    VCard,
    VCardText,
    LottieAnimation,
    VIcon,
    VBadge,
    BizgainStatusLayout,
    VImg,
    VListTile,
    VListTileContent,
    VListTileTitle,
    VListTileAvatar,
    AppConfirmationDialog,
    Stepper
  }
}
</script>
<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');

  .bizgain-status-container{
      height:100vh;
  }

  .left-panel {
    background-size: contain;
  }

  .float-right {
    float: right !important;
  }

  .layout-img {
    background: #13abb1;
    position: absolute;
    height: 100vh;
    width: 33.33%;
  }

  .back-btn {
    cursor: pointer !important;
    z-index: 100 !important;
    width: 30px;
  }

  .back-btn-xs {
    cursor: pointer !important;
    z-index: 100 !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    align-items: center !important;
  }

  .back-btn-disabled {
    cursor: default !important;
    color: #b1b1b1 !important;
  }

  @media (max-width: 599px) {

    .back-btn {
      color: var(--v-white-base);
      position: relative;
      left: 15px;
      top: 4px;
    }

    .back-btn i {
      color: var(--v-white-base) !important;
    }

    .back-btn-disabled i {
      color: #b1b1b1  !important;
    }

    .back-btn-icon-disabled{
      opacity: 0.5 !important;
    }

    .image-card {
      border-radius: 8px !important;
      box-shadow: 8px 8px 16px 0 rgba(0, 0, 0, 0.08) !important;
      background-color: var(--v-white-base) !important;
      margin: auto;
      z-index: 5;
      width: 90%;
      height: 90px;
    }

    .help-text {
      opacity: 0.64;
      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: center;
      color: var(--v-black-base);
      position: relative;
      top: -42px;
    }

    .bounding-box {
      width: 96px;
      height: 96px;
      position: relative;
      top: -46px;
      margin: 0px auto;
    }
  }

  @media (min-width: 600px) and (max-width: 959px) {
      .bounding-box {
        margin: 0px auto;
        height: 140px;
      }

      .image-card-text {
        position: relative;
        top: -50px;
      }

      .help-text {
        opacity: 0.64;
        font-family: 'Open Sans', sans-serif;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: center;
        color: var(--v-black-base);
        position: relative;
        top: 10px;
        padding: 0px 10px;
      }
  }

  @media (min-width: 960px) {
      .bounding-box {
        margin: 0px auto;
        height: 206px;
      }

      .image-card-text {
        position: relative;
        top: -82px;
        margin-bottom: -35px;
      }

      .help-text {
        opacity: 0.64;
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: center;
        color: var(--v-black-base);
        position: relative;
        top: 10px;
        padding: 0px 10px;
      }
  }

  @media (min-width: 600px) {

    .image-card {
      width: 80%;
      // height: 35%;
      border-radius: 8px !important;
      box-shadow: 8px 8px 16px 0 rgba(0, 0, 0, 0.08) !important;
      background-color: var(--v-white-base) !important;
      margin: auto;
      z-index: 5;
    }
  }

  .margin-x-16 {
    margin-left: 16px !important;
    margin-right: 16px !important;
  }

  .margin-x-40 {
    margin-left: 40px !important;
    margin-right: 40px !important;
  }

  ::v-deep.background-image {
    background-size: cover;
  }

  .height-100 {
    height: 100vh !important;
    height: calc(var(--vh, 1vh) * 100) !important;
  }

  .chat-btn{
    font-weight: 600;
    cursor:pointer;
    width: fit-content !important;
    .v-list__tile{
      margin: 6px 7px;
      padding: 0px;
      height: fit-content;
    }
    .chat-badge{
      .custom-chat-icon{
        height: 30px;
        width: 30px;
      }
      .v-list__tile__avatar{
        min-width: 30px;
        white-space: nowrap;
        overflow: hidden;

      }
      .v-badge__badge {
        background: var(--v-error-base);
        border: 2px solid  var(--v-white-base);
        border-radius: 50%;
        font-size: 10px;
        text-align: center;
        height: 18px;
        width: 18px;
      }
  }
}

.chat-badge{
  width: 24px !important;
}

.chat-btn-xs-text, .back-btn-xs-text{
  color: #606060;
}

.header-btn{
  .v-image__image--contain{
    height: 19px !important;
    width: 19px !important;
    margin: 3px 2px !important;
  }
}

@media screen and (max-width: 370px) {
    .chat-btn, .step-indicator{
      padding-left: 0px !important;
    }
}

.layout-header {
  padding-top: 5px !important;
  padding-bottom:10px !important;
  padding-left: 7px !important
}

.layout-fill-height {
  overflow: hidden !important;
}

@media (min-width: 600px){
  .pb-4{
    padding-bottom: 20px !important;
  }
}
</style>